import apiClient from './Api';
const PREFIX = `/dealer`;

const getTeam = postData => {
  return apiClient({
    url: `${PREFIX}/team`,
    method: 'POST',
    data: postData
  });
};

const getProfile = postData => {
  return apiClient({
    url: `${PREFIX}/profile`,
    method: 'POST',
    data: postData
  });
};

const getDealerDmsImportExport = postData => {
  return apiClient({
    url: `${PREFIX}/dmsimpexp`,
    method: 'POST',
    data: postData
  });
};

const getPaProfile = postData => {
  return apiClient({
    url: `${PREFIX}/paprofile`,
    method: 'POST',
    data: postData
  });
};

/* // NOT IN USE
const getDdProfile = postData => {
  return apiClient({
    url: `${PREFIX}/ddprofile`,
    method: 'POST',
    data: postData
  });
};
const getTtmData = postData => {
  return apiClient({
    url: `${PREFIX}/ttmtracker`,
    method: 'POST',
    data: postData
  });
};
const editDealerBillSettings = postData => {
  return apiClient({
    url: `${PREFIX}/editBillSettings`,
    method: 'POST',
    data: postData
  });
};
const stockPhotoSettings = postData => {
  return apiClient({
    url: `${PREFIX}/stockphotosettings`,
    method: 'POST',
    data: postData
  });
};
const saveStockPhotoSettings = postData => {
  return apiClient({
    url: `${PREFIX}/savestockphotosettings`,
    method: 'POST',
    data: postData
  });
};
const toggleOptimizedViewer = postData => {
  return apiClient({
    url: `${PREFIX}/toggleOptimizedImageviewer`,
    method: 'POST',
    data: postData
  });
};
 */

const removeTeamMember = postData => {
  return apiClient({
    url: `${PREFIX}/removephotographer`,
    method: 'POST',
    data: postData
  });
};

const addNewTeamMember = postData => {
  return apiClient({
    url: `${PREFIX}/updatephotographer`,
    method: 'POST',
    data: postData
  });
};

const toggelFeature = postData => {
  return apiClient({
    url: `${PREFIX}/togglefeature`,
    method: 'POST',
    data: postData
  });
};

const toggleReplaceSrpThumb = postData => {
  return apiClient({
    url: `${PREFIX}/togglereplacesrpthumb`,
    method: 'POST',
    data: postData
  });
};

const dealersRoles = postData => {
  return apiClient({
    url: `${PREFIX}/updateroles`,
    method: 'POST',
    data: postData
  });
};

const toggleAutoPublish = postData => {
  return apiClient({
    url: `${PREFIX}/toggleautopublish`,
    method: 'POST',
    data: postData
  });
};

const toggleWindowStickerPublish = postData => {
  return apiClient({
    url: `${PREFIX}/toggleexculdewindowsticker`,
    method: 'POST',
    data: postData
  });
};

const toggleAutoPublishVDS = postData => {
  return apiClient({
    url: `${PREFIX}/toggleautopublishvds`,
    method: 'POST',
    data: postData
  });
};

const toggleGalleryUpload = postData => {
  return apiClient({
    url: `${PREFIX}/toggleGalleryUpload`,
    method: 'POST',
    data: postData
  });
};

const toggleQrWithLabel = postData => {
  return apiClient({
    url: `${PREFIX}/toggleqrwithlabel`,
    method: 'POST',
    data: postData
  });
};

const toggleIntegration = postData => {
  return apiClient({
    url: `${PREFIX}/toggleintegration`,
    method: 'POST',
    data: postData
  });
};

const togglePromoBanner = postData => {
  return apiClient({
    url: `${PREFIX}/togglePromoBanner`,
    method: 'POST',
    data: postData
  });
};

const togglePromoBillboard = postData => {
  return apiClient({
    url: `${PREFIX}/togglepromobillboard`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const toggleOptimizedViewer = postData => {
  return apiClient({
    url: `${PREFIX}/toggleOptimizedImageviewer`,
    method: 'POST',
    data: postData
  });
};

const toggleAllowVdsClone = postData => {
  return apiClient({
    url: `${PREFIX}/toggleallowvdsclone`,
    method: 'POST',
    data: postData
  });
};

/* const toggleMavis = postData => {
  return apiClient({
    url: `${PREFIX}/togglemavis3`,
    method: 'POST',
    data: postData
  });
}; */

const toggleDealerMavisColor = postData => {
  return apiClient({
    url: `${PREFIX}/toggleDealerMavisColor`,
    method: 'POST',
    data: postData
  });
};

const toggleDealerInhouseVideo = postData => {
  return apiClient({
    url: `${PREFIX}/toggleDealerInhouseVideo`,
    method: 'POST',
    data: postData
  });
};

const updateDealerInhouseBgRemoval = postData => {
  return apiClient({
    url: `${PREFIX}/toggledealerinhousebgremoval`,
    method: 'POST',
    data: postData
  });
};

const invLowSettings = postData => {
  return apiClient({
    url: `${PREFIX}/invlowsettings`,
    method: 'POST',
    data: postData
  });
};

const saveInvLowSettings = postData => {
  return apiClient({
    url: `${PREFIX}/saveinvlowsettings`,
    method: 'POST',
    data: postData
  });
};

const getNotes = postData => {
  return apiClient({
    url: `${PREFIX}/getnotes`,
    method: 'POST',
    data: postData
  });
};

const saveNotes = postData => {
  return apiClient({
    url: `${PREFIX}/savenotes`,
    method: 'POST',
    data: postData
  });
};

const getEdProfile = postData => {
  return apiClient({
    url: `${PREFIX}/edprofile`,
    method: 'POST',
    data: postData
  });
};

// Export report
const getReportSettings = postData => {
  return apiClient({
    url: `${PREFIX}/reportsettings`,
    method: 'POST',
    data: postData
  });
};

const saveReportSettings = postData => {
  return apiClient({
    url: `${PREFIX}/savereportsettings`,
    method: 'POST',
    data: postData
  });
};

// Individual Age bucket report
const getAgeBucketReportSettings = postData => {
  return apiClient({
    url: `${PREFIX}/getagebucketreportsettings`,
    method: 'POST',
    data: postData
  });
};

const saveAgeBucketReportSettings = postData => {
  return apiClient({
    url: `${PREFIX}/saveagebucketreportsettings`,
    method: 'POST',
    data: postData
  });
};
const getAgeBucketReportRecipients = postData => {
  return apiClient({
    url: `${PREFIX}/getagebucketreportrecipients`,
    method: 'POST',
    data: postData
  });
};

const getReportRecipients = postData => {
  return apiClient({
    url: `${PREFIX}/recipients`,
    method: 'POST',
    data: postData
  });
};

// VDS report settings
const getVDSReportSettings = postData => {
  return apiClient({
    url: `${PREFIX}/vdsreportsettings`,
    method: 'POST',
    data: postData
  });
};

const saveVDSReportSettings = postData => {
  return apiClient({
    url: `${PREFIX}/savevdsreportsettings`,
    method: 'POST',
    data: postData
  });
};
const getVDSReportRecipients = postData => {
  return apiClient({
    url: `${PREFIX}/getvdsrecipients`,
    method: 'POST',
    data: postData
  });
};

// Import report settings
const getImportReportSettings = postData => {
  return apiClient({
    url: `${PREFIX}/getimportreportsettings`,
    method: 'POST',
    data: postData
  });
};

const saveImportReportSettings = postData => {
  return apiClient({
    url: `${PREFIX}/saveimportreportsettings`,
    method: 'POST',
    data: postData
  });
};

const getImportReportRecipients = postData => {
  return apiClient({
    url: `${PREFIX}/getimportrecipients`,
    method: 'POST',
    data: postData
  });
};

const getWindowStickerSettings = postData => {
  return apiClient({
    url: `${PREFIX}/getstickersettings`,
    method: 'POST',
    data: postData
  });
};

const saveWindowStickerSettings = postData => {
  return apiClient({
    url: `${PREFIX}/savestickersettings`,
    method: 'POST',
    data: postData
  });
};

const getLeadPhoneNumber = postData => {
  return apiClient({
    url: `${PREFIX}/getleadphonenumber`,
    method: 'POST',
    data: postData
  });
};

const getSalesRep = dealerid => {
  return apiClient({
    url: `${PREFIX}/salesrep/${dealerid}`,
    method: 'GET'
  });
};

const getDealerWarranty = dealerid => {
  return apiClient({
    url: `${PREFIX}/warranty/${dealerid}`,
    method: 'GET'
  });
};

const saveSalesRep = postData => {
  return apiClient({
    url: `${PREFIX}/salesrep`,
    method: 'POST',
    data: postData
  });
};

const getInvoiceSettings = postData => {
  return apiClient({
    url: `${PREFIX}/invoicesettings`,
    method: 'POST',
    data: postData
  });
};

const saveInvoiceSettings = postData => {
  return apiClient({
    url: `${PREFIX}/saveinvoicesettings`,
    method: 'POST',
    data: postData
  });
};

const searchVin = postData => {
  return apiClient({
    url: `${PREFIX}/searchvin`,
    method: 'POST',
    data: postData
  });
};

const getViewerSettings = postData => {
  return apiClient({
    url: `${PREFIX}/getviewersettings`,
    method: 'POST',
    data: postData
  });
};

const saveViewerSettings = postData => {
  return apiClient({
    url: `${PREFIX}/saveviewersettings`,
    method: 'POST',
    data: postData
  });
};

const qrLogoUpload = postData => {
  return apiClient({
    url: `${PREFIX}/uploadqrlogo`,
    method: 'POST',
    data: postData
  });
};

const qrLogoRemove = postData => {
  return apiClient({
    url: `${PREFIX}/removeqrlogo`,
    method: 'POST',
    data: postData
  });
};

const removeFontFile = postData => {
  return apiClient({
    url: `${PREFIX}/removefontfile`,
    method: 'POST',
    data: postData
  });
};

const toggleCustomWarrantyForm = postData => {
  return apiClient({
    url: `${PREFIX}/togglecustomwarrantyform`,
    method: 'POST',
    data: postData
  });
};

const togglePrelimRemoveBg = postData => {
  return apiClient({
    url: `${PREFIX}/toggleprelimremovebg`,
    method: 'POST',
    data: postData
  });
};

const toggleExt360RemoveBg = postData => {
  return apiClient({
    url: `${PREFIX}/toggleext360removebg`,
    method: 'POST',
    data: postData
  });
};

const dealerCancellation = postData => {
  return apiClient({
    url: `${PREFIX}/dealercancellation`,
    method: 'POST',
    data: postData
  });
};

const resetDealerCancellation = postData => {
  return apiClient({
    url: `${PREFIX}/resetdealercancellation`,
    method: 'POST',
    data: postData
  });
};

const reactivateDealership = postData => {
  return apiClient({
    url: `${PREFIX}/reactivatedealer`,
    method: 'POST',
    data: postData
  });
};

const orderStickers = postData => {
  return apiClient({
    url: `${PREFIX}/orderstickers`,
    method: 'POST',
    data: postData
  });
};

const windowStickerBuyersguideOrder = postData => {
  return apiClient({
    url: `${PREFIX}/windowStickerBuyersguideOrder`,
    method: 'POST',
    data: postData
  });
};

const addNewDealer = postData => {
  return apiClient({
    url: `${PREFIX}/save`,
    method: 'POST',
    data: postData
  });
};

const updateBodyTypes = postData => {
  return apiClient({
    url: `${PREFIX}/savebodytypes`,
    method: 'POST',
    data: postData
  });
};

const changeDeadLineTime = postData => {
  return apiClient({
    url: `${PREFIX}/updatedeadline`,
    method: 'POST',
    data: postData
  });
};

const getPhotosCountbyHours = postData => {
  return apiClient({
    url: `${PREFIX}/photoscountbyhours`,
    method: 'POST',
    data: postData
  });
};

const getPaProfileDealerComparison = postData => {
  return apiClient({
    url: `${PREFIX}/paprofiledealercomparison`,
    method: 'POST',
    data: postData
  });
};

const getCutoutShots = postData => {
  return apiClient({
    url: `${PREFIX}/cutoutshots`,
    method: 'POST',
    data: postData
  });
};

const getWarrantyType = postData => {
  return apiClient({
    url: `${PREFIX}/getwarranty`,
    method: 'POST',
    data: postData
  });
};

const saveWarrantyType = postData => {
  return apiClient({
    url: `${PREFIX}/savewarranty`,
    method: 'POST',
    data: postData
  });
};

const getExportAttentionRecipients = postData => {
  return apiClient({
    url: `${PREFIX}/exportattentionrecipients`,
    method: 'GET',
    params: postData
  });
};

const saveExportAttentionRecipients = postData => {
  return apiClient({
    url: `${PREFIX}/exportattentionrecipients`,
    method: 'POST',
    data: postData
  });
};

const sendExportAttentionMail = postData => {
  return apiClient({
    url: `${PREFIX}/sendexportattentionmail`,
    method: 'POST',
    data: postData
  });
};

const saveExportAttentionTime = postData => {
  return apiClient({
    url: `${PREFIX}/saveexportattentiontime`,
    method: 'POST',
    data: postData
  });
};

// const toggleIsMavis3 = postData => {
//   return apiClient({
//     url: `${PREFIX}/togglemavis3`,
//     method: 'POST',
//     data: postData
//   });
// };

const downloadDealerNotUploaded = (postData = {}) => {
  return apiClient({
    url: `${PREFIX}/downloaddealernotuploaded`,
    method: 'POST',
    data: postData
  });
};

const toggleMatchVDS = postData => {
  return apiClient({
    url: `${PREFIX}/togglematchvds`,
    method: 'POST',
    data: postData
  });
};

const toggleLightVDS = postData => {
  return apiClient({
    url: `${PREFIX}/togglelightvds`,
    method: 'POST',
    data: postData
  });
};

const toggleImportDownload = postData => {
  return apiClient({
    url: `${PREFIX}/toggleimportdownload`,
    method: 'POST',
    data: postData
  });
};

const toggleShareVehicle = postData => {
  return apiClient({
    url: `${PREFIX}/togglesharevehicle`,
    method: 'POST',
    data: postData
  });
};

const toggleDealersPhotographerForceLogout = postData => {
  return apiClient({
    url: `${PREFIX}/toggleforcelogout`,
    method: 'POST',
    data: postData
  });
};
const toggleEncPhotonUrls = postData => {
  return apiClient({
    url: `${PREFIX}/toggleencphotonurls`,
    method: 'POST',
    data: postData
  });
};

const getCopyVDSGroup = postData => {
  return apiClient({
    url: `${PREFIX}/getcopyvdsgroup`,
    method: 'POST',
    data: postData
  });
};

const saveCopyVDSGroup = postData => {
  return apiClient({
    url: `${PREFIX}/savecopyvdsgroup`,
    method: 'POST',
    data: postData
  });
};

const removeCopyVDSGroup = postData => {
  return apiClient({
    url: `${PREFIX}/removecopyvdsgroup`,
    method: 'POST',
    data: postData
  });
};

const getPaUploadGroup = postData => {
  return apiClient({
    url: `${PREFIX}/getpauploadgroup`,
    method: 'POST',
    data: postData
  });
};

const savePaUploadGroup = postData => {
  return apiClient({
    url: `${PREFIX}/savepauploadgroup`,
    method: 'POST',
    data: postData
  });
};

const removePaUploadGroup = postData => {
  return apiClient({
    url: `${PREFIX}/removepauploadgroup`,
    method: 'POST',
    data: postData
  });
};

const getRatio = postData => {
  return apiClient({
    url: `${PREFIX}/getratio`,
    method: 'POST',
    data: postData
  });
};

const toggleExportUpload = postData => {
  return apiClient({
    url: `${PREFIX}/toggleexportupload`,
    method: 'POST',
    data: postData
  });
};

const updateDealerRatio = postData => {
  return apiClient({
    url: `${PREFIX}/updateratio`,
    method: 'POST',
    data: postData
  });
};

const imperfectionRatioList = postData => {
  return apiClient({
    url: `${PREFIX}/imperfectionratiolist`,
    method: 'POST',
    data: postData
  });
};

const saveCustomWidth = postData => {
  return apiClient({
    url: `${PREFIX}/customwidth`,
    method: 'POST',
    data: postData
  });
};

const saveDealerEditQueueAndManualOverride = postData => {
  return apiClient({
    url: `${PREFIX}/savedealerqueueandmanualoverride`,
    method: 'POST',
    data: postData
  });
};

const downloadPaProfileData = postData => {
  return apiClient({
    url: `${PREFIX}/paprofildownloadsheet`,
    method: 'POST',
    data: postData,
    responseType: 'blob'
  });
};

const getPhotoPreferenceNotes = params => {
  return apiClient({
    url: `${PREFIX}/get-photo-pref-notes`,
    method: 'GET',
    params
  });
};

const toggleAllowIphoneApp = postData => {
  return apiClient({
    url: `${PREFIX}/toggleallowiphoneapp`,
    method: 'POST',
    data: postData
  });
};

const toggleAllowStickerOrder = data => {
  return apiClient({
    url: `${PREFIX}/toggle-sticker-order-dashboard`,
    method: 'PUT',
    data
  });
};

const getAllRecipients = postData => {
  return apiClient({
    url: `${PREFIX}/getrecipients`,
    method: 'POST',
    data: postData
  });
};

const saveAllRecipients = data => {
  return apiClient({
    url: `${PREFIX}/savereportemails`,
    method: 'POST',
    data
  });
};

const updateRecipientReports = data => {
  return apiClient({
    url: `${PREFIX}/updatereportemails`,
    method: 'POST',
    data
  });
};

const deleteRecipient = postData => {
  return apiClient({
    url: `${PREFIX}/deleterecipient`,
    method: 'DELETE',
    data: postData
  });
};

const toggleAllowUploadEmailNotification = postData => {
  return apiClient({
    url: `${PREFIX}/toggleallowuploadnotification`,
    method: 'POST',
    data: postData
  });
};

const saveAddendumStickerSettings = postData => {
  return apiClient({
    url: `${PREFIX}/save-addendum-sticker-settings`,
    method: 'POST',
    data: postData
  });
};

const DealerService = {
  saveCustomWidth,
  getCopyVDSGroup,
  saveCopyVDSGroup,
  removeCopyVDSGroup,
  getPaUploadGroup,
  savePaUploadGroup,
  removePaUploadGroup,
  // toggleIsMavis3,
  getWarrantyType,
  saveWarrantyType,
  saveViewerSettings,
  getViewerSettings,
  getSalesRep,
  saveSalesRep,
  getDealerWarranty,
  /* toggleMavis, */
  toggleDealerMavisColor,
  toggleDealerInhouseVideo,
  updateDealerInhouseBgRemoval,
  getLeadPhoneNumber,
  getWindowStickerSettings,
  saveWindowStickerSettings,
  toggleReplaceSrpThumb,
  getTeam,
  getImportReportRecipients,
  getImportReportSettings,
  saveImportReportSettings,
  getReportSettings,
  saveReportSettings,
  invLowSettings,
  getAgeBucketReportSettings,
  saveAgeBucketReportSettings,
  getAgeBucketReportRecipients,
  saveInvLowSettings,
  getEdProfile,
  getNotes,
  saveNotes,
  getReportRecipients,
  getVDSReportSettings,
  saveVDSReportSettings,
  getVDSReportRecipients,
  getProfile,
  getDealerDmsImportExport,
  getPaProfile,
  removeTeamMember,
  addNewTeamMember,
  toggelFeature,
  dealersRoles,
  toggleAutoPublish,
  toggleAutoPublishVDS,
  toggleQrWithLabel,
  toggleIntegration,
  togglePromoBanner,
  togglePromoBillboard,
  toggleOptimizedViewer,
  toggleGalleryUpload,
  toggleAllowVdsClone,
  getInvoiceSettings,
  saveInvoiceSettings,
  searchVin,
  qrLogoUpload,
  qrLogoRemove,
  removeFontFile,
  toggleCustomWarrantyForm,
  togglePrelimRemoveBg,
  toggleExt360RemoveBg,
  dealerCancellation,
  resetDealerCancellation,
  toggleWindowStickerPublish,
  orderStickers,
  windowStickerBuyersguideOrder,
  addNewDealer,
  updateBodyTypes,
  changeDeadLineTime,
  getPhotosCountbyHours,
  getPaProfileDealerComparison,
  getCutoutShots,
  getExportAttentionRecipients,
  saveExportAttentionRecipients,
  sendExportAttentionMail,
  saveExportAttentionTime,
  // getTtmData,
  // editDealerBillSettings,
  // getDdProfile,
  // saveStockPhotoSettings,
  // stockPhotoSettings,
  // toggleOptimizedViewer,
  downloadDealerNotUploaded,
  toggleMatchVDS,
  toggleLightVDS,
  toggleImportDownload,
  toggleDealersPhotographerForceLogout,
  toggleEncPhotonUrls,
  getRatio,
  updateDealerRatio,
  imperfectionRatioList,
  toggleExportUpload,
  saveDealerEditQueueAndManualOverride,
  reactivateDealership,
  downloadPaProfileData,
  toggleShareVehicle,
  getPhotoPreferenceNotes,
  toggleAllowIphoneApp,
  toggleAllowStickerOrder,
  getAllRecipients,
  saveAllRecipients,
  updateRecipientReports,
  deleteRecipient,
  toggleAllowUploadEmailNotification,
  saveAddendumStickerSettings
};

export default DealerService;
